<div class="contact-form-overlay" (click)="onToggle()"></div>
<div class="contact-form-wrapper">
  <ng-content select="[before-contact-form-button]" />

  <button class="contact-form-button btn btn-primary" translate="Actions.ContactUs" data-cy="ContactUs" (click)="onToggle()"></button>
  <div class="contact-form">
    <form [formGroup]="form" [class.block-loader]="formLoader.isLoading$ | async" (submit)="onSubmit()">
      <h2 translate="ContactForm.Title"></h2>
      <div class="form-section">
        <loader-spinner [model]="formLoader"/>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label" for="field-contact-lastname" translate="ContactForm.Lastname"></label>
              <input class="form-control form-control-alt" id="field-contact-lastname" type="text" formControlName="lastName" [class.is-invalid]="lastnameField.dirty && lastnameField.invalid">
              <form-control-feedback [field]="lastnameField"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label" for="field-contact-firstname" translate="ContactForm.Firstname"></label>
              <input class="form-control form-control-alt" id="field-contact-firstname" type="text" formControlName="firstName" [class.is-invalid]="firstnameField.dirty && firstnameField.invalid">
              <form-control-feedback [field]="firstnameField"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label" for="field-contact-email" translate="ContactForm.Email"></label>
              <input class="form-control form-control-alt" id="field-contact-email" type="text" formControlName="email" [class.is-invalid]="emailField.dirty && emailField.invalid">
              <form-control-feedback [field]="emailField"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label" for="field-contact-phone" translate="ContactForm.Phone"></label>
              <input class="form-control form-control-alt" id="field-contact-phone" type="text" formControlName="phoneNumber" [class.is-invalid]="phoneNumberField.dirty && phoneNumberField.invalid">
              <form-control-feedback [field]="phoneNumberField"/>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="field-contact-subject" translate="ContactForm.Subject.Title"></label>
          <select class="form-control form-control-alt" id="field-contact-subject" type="text" formControlName="subject" autocomplete="off">
            <option value="" disabled translate="ContactForm.Select"></option>
            @for (subject of subjects; track subject) {
              <option [value]="subject | translate" [translate]="subject"></option>
            }
          </select>
          <form-control-feedback [field]="subjectField"/>
        </div>

        <div class="form-group">
          <label class="form-label" for="field-contact-body" translate="ContactForm.Body"></label>
          <textarea class="form-control form-control-alt" id="field-contact-body" formControlName="body" [class.is-invalid]="bodyField.dirty && bodyField.invalid"></textarea>
          <form-control-feedback [field]="bodyField"/>
        </div>

        <div class="form-group">
          <div class="form-check">
            <input id="field-contact-canRecall" class="form-check-input" type="checkbox" formControlName="canRecall" />
            <label class="form-check-label" for="field-contact-canRecall" translate="ContactForm.CanRecall"></label>
          </div>
        </div>

        <div class="row" [class.is-disabled]="!isCanRecallChecked">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label" for="field-contact-date" translate="ContactForm.Date"></label>
              <form-datepicker
                formControlName="recallDate"
                [control]="recallDateField"
                [class.is-invalid]="recallDateField.dirty && recallDateField.invalid"
                [forcePropagation]="true"
                controlId="field-contact-date"
                placement="top"
                [isDisabled]="!isCanRecallChecked"
                [minDate]="recallDateMin"
                />
              <form-control-feedback [field]="recallDateField"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label" for="field-contact-recall" translate="ContactForm.RecallTime.Title"></label>
              <select class="form-control form-control-alt" id="field-contact-recall" type="text" autocomplete="off" formControlName="recallTime" [class.is-invalid]="recallTimeField.dirty && recallTimeField.invalid">
                <option value="" disabled translate="ContactForm.Select"></option>
                @for (time of recallTimes; track time) {
                  <option [value]="time | translate" [translate]="time"></option>
                }
              </select>
              <form-control-feedback [field]="recallTimeField"/>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-text" translate="Forms.RequiredFields"></div>
        </div>

        <div class="row">
          <div class="col">
            <button class="btn btn-light btn-block" type="button" translate="Actions.Cancel" data-cy="Cancel" (click)="onToggle()"></button>
          </div>
          <div class="col">
            <button class="btn btn-secondary btn-block" type="submit" translate="Actions.Submit" data-cy="Submit" [disabled]="form.invalid"></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
